import { render, staticRenderFns } from "./Home_PC.vue?vue&type=template&id=bd5ab222&scoped=true"
import script from "./Home_PC.vue?vue&type=script&lang=js"
export * from "./Home_PC.vue?vue&type=script&lang=js"
import style0 from "../assets/css/PC.scss?vue&type=style&index=0&id=bd5ab222&prod&lang=scss&scoped=true&external"
import style1 from "./Home_PC.vue?vue&type=style&index=1&id=bd5ab222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5ab222",
  null
  
)

export default component.exports